<template>
  <div
    class="w-container w-justify-content-start w-col py-5"
    style="height: 100%"
  >
    <div class="form text-center" style="z-index: 15; height: 100%">
      <div
        class="title-logo"
        :class="{
          'pb-4': $vuetify.breakpoint.smAndUp,
          'pb-2': $vuetify.breakpoint.xsOnly,
        }"
      >
        <img alt="Logo" src="/logo.png" />
      </div>
      <div class="text-h3 user-text">Oops!</div>
      <div class="text-h6 user-text pt-4">
        To access your event's app, please use the link provided by the
        organization or the one you recieved after your sign up process.
      </div>
    </div>
    <login-image />
  </div>
</template>

<script>
export default {
  props: ["routeNames", "auth"],
  data() {
    return {};
  },
};
</script>
<style lang="scss"></style>
